import React from "react";
import { GetAppText, StyleClass } from "../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import SvgComponent from "../../../components/SvgComponent";
import { switchTabHandler } from "../../../../store/slices/sideBarSlice";

export const MyAccount = ({ toggleSideBar }) => {
  const language = useSelector((state) => state.language.value);
  const dispatch = useDispatch();
  const data = [
    {
      id: 1,
      name: GetAppText("personal_information"),
      component: "",
      icon: "User",
    },
    {
      id: 2,
      name: GetAppText("account_settings"),
      component: "",
      icon: "Settings",
    },
    {
      id: 3,
      name: GetAppText("donation_record"),
      component: "",
      icon: "Clock",
    },
  ];
  const handleSelectOption = (option) => {
    dispatch(switchTabHandler(option.id));
    toggleSideBar({ value: true, id: option.id });
  };
  return (
    <div className="w-full h-full">
      <h1
        className={`text-F18 text-primary ${
          language === "_ar" ? "text-right" : "text-left"
        }`}
      >
        {GetAppText("my_account")}
      </h1>
      <div className="pt-4 flex flex-col space-y-4">
        {data.map((item) => (
          <div
            className="p-4 bg-white rounded-md cursor-pointer"
            key={item.id}
            onClick={() => handleSelectOption(item)}
          >
            <div
              className={`flex justify-between items-center ${StyleClass()}`}
            >
              <div className={`flex items-center space-x-3 ${StyleClass()}`}>
                <SvgComponent
                  name={item.icon}
                  className={"w-5 h-5"}
                  stroke={"black"}
                  fill={"none"}
                />
                <span className="text-black text-F16 font-semibold">
                  {item.name}
                </span>
              </div>
              <div>
                <SvgComponent
                  name={language === "_ar" ? "ChevronLeft" : "ChevronRight"}
                  className={"w-6 h-6"}
                  stroke={"black"}
                  fill={"none"}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
